const keyboardDatePickerFormService = {
  label: 'Service Date'
};

export default keyboardDatePickerFormService;
